module.exports = {
  communities: 'Communities',
  home: 'Home',
  mediacenter: 'Mediathek',
  vouchers: 'Voucher-Codes',
  courses: 'Kurse',
  appointments: 'Termine',
  logout: 'Ausloggen',
  feedback: 'Feedback / App bewerten',
  training: 'Training',
  features: 'Funktionen',
  information: 'Informationen',
  learning: 'Lernen',
  language: 'Sprache',
  more: 'Mehr',
  menu: 'Menü',
  profile_settings: 'Profildaten ändern',
  notification_settings: 'Notifications',
  powerlearning: 'Powerlearning',
  profile: 'Profil',
  quiz: 'Quiz-Battle',
  todolists: 'Aufgaben',
  statistics: 'Statistiken',
  tests: 'Tests',
  webinars: 'Webinare',
  mobile_navigation: 'Mobile Navigation',
}
